// router/crm.js
import { useAdminAuthStore } from "@/store/adminAuthStore";

const crm_router = [
  // Маршрут авторизации
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/SignIn.vue"),
    meta: { requiresGuest: true },
    beforeEnter: async (to, from, next) => {
      const adminAuthStore = useAdminAuthStore();

      // Проверяем авторизацию
      const isAuthenticated = await adminAuthStore.checkAuthStatus();

      if (isAuthenticated) {
        next({
          name: "dashboard",
        });
      } else {
        next();
      }
    },
  },

  // Основной административный раздел
  {
    path: `/admin`,
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      const adminAuthStore = useAdminAuthStore();

      // Проверяем авторизацию
      const isAuthenticated = await adminAuthStore.checkAuthStatus();

      if (isAuthenticated) {
        next();
      } else {
        // Очищаем данные если токен недействителен
        adminAuthStore.clearAuthData();
        next({
          name: "auth",
        });
      }
    },
    children: [
      {
        path: "",
        name: "dashboard-home",
        component: () => import("../views/CRM/DashboardHome.vue"),
        meta: { title: "Панель управления" },
      },
      {
        path: "categories",
        name: "categories-crm",
        component: () => import("../views/CRM/Categories.vue"),
        meta: { title: "Categories" },
      },
      {
        path: "products",
        name: "products-crm",
        component: () => import("../views/CRM/Products.vue"),
        meta: { title: "Products" },
      },
      {
        path: "blogs",
        name: "blogs-crm",
        component: () => import("../views/CRM/BlogPage.vue"),
        meta: { title: "Blog" },
      },
      {
        path: "hashtags",
        name: "hashtags-crm",
        component: () => import("../views/CRM/HashtagPage.vue"),
        meta: { title: "Hashtags" },
      },
      {
        path: "orders",
        name: "orders-crm",
        component: () => import("../views/CRM/OrdersPage.vue"),
        meta: { title: "Список Заказов" },
      },
      {
        path: "leads",
        name: "leads-crm",
        component: () => import("../views/CRM/LeadsPage.vue"),
      },
      {
        path: "change-password",
        name: "change-password-crm",
        component: () => import("../views/CRM/ChangePasswordPage.vue"),
      },
    ],
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter: async (to, from, next) => {
      const adminAuthStore = useAdminAuthStore();

      if (adminAuthStore.isAuthenticated) {
        await adminAuthStore.logout();
      }

      next({
        name: "auth",
        query: { message: "logout_success" },
      });
    },
  },

  // Принудительный выход из всех сессий
  {
    path: "/logout-all",
    name: "logout-all",
    beforeEnter: async (to, from, next) => {
      const adminAuthStore = useAdminAuthStore();

      if (adminAuthStore.isAuthenticated) {
        await adminAuthStore.terminateAllSessions();
      }

      next({
        name: "auth",
        query: { message: "logout_all_success" },
      });
    },
  },
];

// === ГЛОБАЛЬНЫЕ НАВИГАЦИОННЫЕ ХУКИ ===

// Хук для проверки авторизации перед каждым переходом
export const setupAuthGuards = (router) => {
  router.beforeEach(async (to, from, next) => {
    const adminAuthStore = useAdminAuthStore();

    // Инициализируем store если еще не инициализирован
    if (!adminAuthStore.token && !adminAuthStore.isInitializing) {
      adminAuthStore.init();
    }

    // Проверяем требования маршрута
    const requiresAuth = to.meta.requiresAuth;
    const requiresGuest = to.meta.requiresGuest;

    if (requiresAuth) {
      // Маршрут требует авторизации
      const isAuthenticated = await adminAuthStore.checkAuthStatus();

      if (!isAuthenticated) {
        adminAuthStore.clearAuthData();
        next({
          name: "auth",
          query: { redirect: to.fullPath, message: "auth_required" },
        });
        return;
      }
    } else if (requiresGuest) {
      // Маршрут только для неавторизованных пользователей
      if (adminAuthStore.isAuthenticated) {
        next({ name: "dashboard" });
        return;
      }
    }

    // Устанавливаем заголовок страницы
    if (to.meta.title) {
      document.title = `${to.meta.title} - Admin Panel`;
    }

    next();
  });
};

// === ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ ===

// Функция для программного перехода с проверкой авторизации
export const navigateWithAuth = (router, routeName, params = {}) => {
  const adminAuthStore = useAdminAuthStore();

  if (!adminAuthStore.isAuthenticated) {
    router.push({
      name: "auth",
      query: { redirect: router.resolve({ name: routeName, params }).href },
    });
    return false;
  }

  router.push({ name: routeName, params });
  return true;
};

export default crm_router;
